import React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";

import "./breadCrumb.scss";

import {
  TEMPLATES,
  TEMPLATES_URI,
} from "../../utils/constants";

const getUri = (uri = "", templateName = "") => {
  switch (templateName) {
    case TEMPLATES.HOME:
      return TEMPLATES_URI.HOME;
    case TEMPLATES.SECTION:
      return TEMPLATES_URI.EMPTY;
    default:
      return uri;
  }
};

const getBreadCrumb = (uri = "", allPagesData = {}) => {
  if (!uri) {
    return [];
  }
  const { title = "", templateName = "", parentUri = "" } =
    allPagesData[uri] || {};
  let breadCrumb = getBreadCrumb(parentUri, allPagesData);
  if (templateName !== TEMPLATES.SECTION) {
    breadCrumb.push({
      title: title,
      uri: getUri(uri, templateName),
    });
    breadCrumb.push({ title: TEMPLATES_URI.SEPERATOR }); // adding a slash after each level
  }
  return breadCrumb;
};

const BreadCrumb = ({ allPagesData = {}, uri = "" }) => {
  const breadCrumb = getBreadCrumb(uri, allPagesData);

  return (
    <div className="bread-crumb">
      <div className="bread-crumb-content">
        {breadCrumb?.map(page => {
          const { title = "", uri = "" } = page || {};
          return (
            <>
              {uri ? (
                <Link
                  className="bread-crumb-link"
                  to={uri}
                  key={uri}
                >
                  <p className="bread-crumb-title">
                    {title}
                  </p>
                </Link>
              ) : (
                <p className="bread-crumb-link bread-crumb-title">
                  {title}
                </p>
              )}
            </>
          );
        })}
      </div>
    </div>
  );
};

BreadCrumb.propTypes = {
  allPagesData: PropTypes.object,
  uri: PropTypes.string,
};

export default BreadCrumb;
